
















import { Component, Vue } from 'vue-property-decorator';
import VEmojiPicker from 'v-emoji-picker';
import { IEmoji } from 'v-emoji-picker/lib/models/Emoji';

const EMOJI_PICKER_DIMENSIONS = {
    emojiHeight: 440,
    emojiWidth: 350
};

@Component({
    components: { VEmojiPicker }
})
export default class EmojiPicker extends Vue {
	show: boolean = false;

	public toggle() {
	    this.show = !this.show;
	}

	public open() {
	    this.show = true;
	}

	public close() {
	    this.show = false;
	}

	style() {
	    const { emojiHeight, emojiWidth } = EMOJI_PICKER_DIMENSIONS;
	    const { innerHeight, innerWidth } = window;
	    const { y, height, width, right } = this.$el.getBoundingClientRect();
	    const screenTop = document.getElementById('topnavbar')!.getBoundingClientRect().bottom;

	    const absoluteHeight = emojiHeight / 2;
	    const distToTop = y - screenTop;
	    const distToBot = innerHeight - y;

	    let newY = 0;

	    // Check if we can center it
	    if (distToTop - absoluteHeight > 0 && distToBot - absoluteHeight > 0) {
	        newY = -absoluteHeight;
	    } else {
	        const overflowBottom = innerHeight - y - emojiHeight;
	        if (overflowBottom < 0) {
	            newY = -(emojiHeight - height);

	            if (distToTop - emojiHeight < 0) {
	                newY -= distToTop - emojiHeight;
	            }
	        }
	    }

	    let newX = width;

	    const overflowRight = innerWidth - right - emojiWidth;
	    if (overflowRight < 0) {
	        newX += overflowRight;
	    }

	    return {
	        left: newX + 'px',
	        top: newY + 'px'
	    };
	}

	selectEmoji(emoji: IEmoji) {
	    this.$emit('emoji', emoji.data);
	}
}
